import React, { useState, useEffect } from 'react';
import './Lobby.css'; // We'll create this for styling
import { findOrCreateUser, createGameRoom, joinGameRoom } from '../services/api';

function Lobby({ onJoinGame, currentUser, setCurrentUser }) {
  const [usernameInput, setUsernameInput] = useState('');
  const [roomCodeInput, setRoomCodeInput] = useState(''); // Renamed from roomCode for clarity
  const [error, setError] = useState('');

  useEffect(() => {
    if (currentUser) {
      setUsernameInput(currentUser.username);
    }
  }, [currentUser]);

  // Validation logic for buttons
  const isCreateButtonDisabled = !usernameInput.trim() && !currentUser;
  const isJoinButtonDisabled = (!usernameInput.trim() && !currentUser) || !roomCodeInput.trim();

  const handleUsernameSubmit = async () => {
    if (!usernameInput.trim()) {
      setError('Please enter a username.');
      return null;
    }
    try {
      setError('');
      const user = await findOrCreateUser(usernameInput.trim());
      setCurrentUser(user); // Save user in App state
      return user;
    } catch (err) {
      setError('Failed to create or find user. Please try again.');
      return null;
    }
  };

  const handleCreateRoom = async () => {
    let user = currentUser;
    if (!user) {
      user = await handleUsernameSubmit();
    }
    if (!user) return; // Stop if user creation/retrieval failed

    try {
      setError('');
      const gameRoom = await createGameRoom(user.id);
      onJoinGame(user, gameRoom); // Notify App.js to switch view
    } catch (err) {
      setError('Failed to create room. Please try again.');
    }
  };

  const handleJoinRoom = async () => {
    if (!roomCodeInput.trim()) {
      setError('Please enter a room code.');
      return;
    }
    let user = currentUser;
    if (!user) {
      user = await handleUsernameSubmit();
    }
    if (!user) return; // Stop if user creation/retrieval failed

    try {
      setError('');
      const gameRoom = await joinGameRoom(roomCodeInput.trim().toUpperCase(), user.id); // Standardize to uppercase
      onJoinGame(user, gameRoom); // Notify App.js to switch view
    } catch (err) {
      setError('Failed to join room. Check room code or try again.');
    }
  };

  return (
    <div className="lobby-container"> {/* Background image will be set via CSS */}
      <div className="lobby-card"> {/* Renamed from lobby-content for clarity */}
        <div className="lobby-header">
          <span className="gamepad-icon" role="img" aria-label="gamepad">🎮</span>
          <h1>Get Started</h1>
          <p className="lobby-subtitle">
            Enter your username and create or join a game of UNO!
          </p>
        </div>

        {error && <p className="error-message">{error}</p>}

        <div className="lobby-form">
          <input
            type="text"
            placeholder="Enter your username"
            value={usernameInput}
            onChange={(e) => setUsernameInput(e.target.value)}
            className="lobby-input"
            disabled={!!currentUser}
          />
          
          <button 
            onClick={handleCreateRoom} 
            className="lobby-button create-new-game-button"
            disabled={isCreateButtonDisabled}
          >
            Create New Game
          </button>

          <div className="or-separator">
            <span>OR</span>
          </div>

          <input
            type="text"
            placeholder="ENTER ROOM CODE (E.G. AB123)"
            value={roomCodeInput}
            onChange={(e) => setRoomCodeInput(e.target.value.toUpperCase())} // Ensure uppercase
            className="lobby-input room-code-input"
            maxLength={6} // Assuming room codes are 6 chars like "AB1234"
            // style={{ textTransform: 'uppercase' }} // Handled by toUpperCase() in onChange
          />
          <button 
            onClick={handleJoinRoom} 
            className="lobby-button join-game-button"
            disabled={isJoinButtonDisabled}
          >
            Join Game
          </button>
        </div>
      </div>
    </div>
  );
}

export default Lobby;
